/** Rings the map draws that the stored plan does not carry: the margin outline and a photo's footprint. */
import { frameAround, rotate, toLocal, toWgs } from './frame';
import { bearingToMath } from './index';
import { buffer, ring } from './polygon';
import type { LngLat } from './types';

export function bufferedRing(polygon: LngLat[], margin_m: number): LngLat[] {
  if (polygon.length < 3) return [];
  const f = frameAround(polygon);
  return buffer(ring(polygon.map((p) => toLocal(f, p))), margin_m).map((p) => toWgs(f, p));
}

/** The ground rectangle of one photo: `along_m` in the flight direction, `across_m` perpendicular to it. */
export function footprintRing(center: LngLat, bearing: number, across_m: number, along_m: number): LngLat[] {
  const f = frameAround([center]);
  const c = toLocal(f, center);
  const math = bearingToMath(bearing);
  return [
    { x: -along_m / 2, y: -across_m / 2 },
    { x: along_m / 2, y: -across_m / 2 },
    { x: along_m / 2, y: across_m / 2 },
    { x: -along_m / 2, y: across_m / 2 },
  ].map((p) => {
    const r = rotate(p, math);
    return toWgs(f, { x: c.x + r.x, y: c.y + r.y });
  });
}
